

























import Vue from 'vue';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import store from '@/store';
import * as CvStore from '@/containers/cv/store';
import * as CvSectionProfileStore from '@/containers/cv-section-profile/store';
import SectionsContainer from '@/containers/cvs/sections.vue';
import { createNamespacedHelpers } from 'vuex';

const cvStoreMapper = createNamespacedHelpers(CvStore.namespace);
const cvSectionProfileMapper = createNamespacedHelpers(
  CvSectionProfileStore.namespace
);

const fetch = async params => {
  const { cv_id } = params;
  await Promise.all([
    store.dispatch(CvStore.GetCv.namespaced({ cv_id })),
    store.dispatch(CvStore.GetCvCvSections.namespaced({ cv_id })),
    store.dispatch(
      CvSectionProfileStore.GetCvSectionProfile.namespaced({ cv_id })
    ),
  ]);
};

export default Vue.extend({
  components: {
    SectionsContainer,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvStore, CvSectionProfileStore],
    };
  },
  computed: {
    ...cvStoreMapper.mapGetters(['cv', 'cvSections', 'cvDesignTemplate']),
    ...cvSectionProfileMapper.mapGetters(['cvSectionProfile']),
    isEditing() {
      return this.$route.name !== 'cv_edit_path';
    },
    // PC: always shown
    // SP: only on not editing
    showCvSections() {
      return this.$ua.isMobile ? !this.isEditing : true;
    },
    cvId(): string {
      return this.$route.params.cv_id;
    },
  },
});
